import React from "react";

/**
 * White, rounded, shadowed container. Replaces the repeated
 * `shadow overflow-hidden sm:rounded-md` > `px-4 py-5 bg-white sm:p-6` wrapper.
 */
function Card({ className = "", bodyClassName = "", children }) {
  return (
    <div
      className={`bg-white rounded-xl shadow-sm ring-1 ring-gray-900/5 overflow-hidden ${className}`}
    >
      <div className={`px-4 py-5 sm:p-6 ${bodyClassName}`}>{children}</div>
    </div>
  );
}

export default Card;
